import { atom } from "recoil"

export const listMatchingMessageRequestIdState = atom<number>({
  key: "atoms/matching/listMatchingMessageRequestIdState",
  default: 0,
})
